<template>
	<NuxtLayout name="default">
		<ErrorPage
			v-if="error"
			:status-code="error.statusCode"
			:status-message="error.statusMessage"
			:message="error.message"
		/>
	</NuxtLayout>
</template>

<script setup>
const error = useError();

const config = useRuntimeConfig();

useHead({
	title: `${error?.statusCode} - ${error?.statusMessage}`,
	...(config.public.indexable === false
		? {
				meta: [
					{
						name: "robots",
						content: "noindex, nofollow"
					}
				]
			}
		: {})
});
</script>
